<template>
  <button
    class="site-header-garage"
    :class="[
      `site-header-garage--${template}`,
      { [$class('active')]: activeVehicle },
    ]"
    type="button"
    :aria-expanded="activeOverlay"
    aria-haspopup="dialog"
    @click="openFinderFlow('both')"
  >
    <icon-garage />

    <span class="site-header-garage__label-container">
      <span
        v-if="activeVehicle"
        class="site-header-garage__active-label"
      >
        <span
          class="
            site-header-garage__garage
            text-body-xs-bold
            text-body-s-bold-desktop
          "
          v-text="garageString"
        />

        <span
          class="
            site-header-garage__vehicle
            text-body-xs-bold
            text-body-s-bold-desktop
          "
          v-text="activeVehicle.strings?.title"
        />
      </span>

      <span
        class="site-header-garage__inactive-label"
        :aria-hidden="Boolean(activeVehicle)"
      >
        <span
          class="
            site-header-garage__garage
            text-body-xs-bold
            text-body-s-bold-desktop
          "
          v-text="garageString"
        />

        <span
          class="
            site-header-garage__vehicle
            text-body-xs-regular
            text-body-s-regular-desktop
          "
          v-text="$string('garage.add_vehicle')"
        />
      </span>
    </span>

    <icon-chevron-right />
  </button>
</template>

<script>

/**
 * Vue: Site header garage (site-header-garage)
 * -----------------------------------------------------------------------------
 * Garage button in site header to trigger vehicle finder modal.
 *
 * @param {String} template - Location of button, `mobile` or `desktop`.
 *
 */
import { mapActions, mapGetters } from 'vuex'

import IconGarage from '~icons/general/garage.svg'
import IconChevronRight from '~icons/directional-navigation/chevron/right.svg'

export default {
  name: 'SiteHeaderGarage',

  components: {
    IconGarage,
    IconChevronRight,
  },

  props: {
    template: {
      type: String,
      default: 'mobile',
      required: true,
    },
  },

  data() {
    return {
      cnvsGlobal: true,
    }
  },

  computed: {

    /**
     * Map Vuex getters.
     */
    ...mapGetters({
      activeVehicle: 'garage/getActiveVehicle',
      garageCount: 'garage/getGarageCount',
      getActiveOverlay: 'overlays/getActiveOverlay',
    }),

    /**
     * Compute if related overlay is active.
     * @returns {Boolean}
     */
    activeOverlay() {
      return [
        'garageModal',
        'vehicleFinderModal',
      ].includes(this.getActiveOverlay?.namespace)
    },

    /**
     * Compute garage string.
     * @returns {String}
     */
    garageString() {
      return this.$string('garage.my_garage', {
        pluralise: this.garageCount,
        replace: { count: this.garageCount },
      })
    },
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      openFinderFlow: 'garage/openFinderFlow',
    }),
  },
}
</script>
